const n = "_CTAContainer_1hjy4_1", t = {
  CTAContainer: n
};
export {
  n as CTAContainer,
  t as default
};
//# sourceMappingURL=index.es5603.js.map
